import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	defaultIntegrations: false,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration({
			beforeErrorSampling: (event) =>
				event.tags?.web_notification_closed_job === true,
		}),
	],
	tracesSampleRate: 0.1,
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 1.0,
	environment: process.env.REACT_APP_SENTRY_ENV ?? 'local',
});

import './input.css';
import './output.css';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import 'src/_shared/phone.js';
import { takeOverShellSsoReturn } from 'src/_shared/shell.js';
import App from './app.component';
import { WithApiProvider } from 'src/_shared/api/index.js';
import ErrorHandler from './error-handler.jsx';

Amplify.configure({
	Auth: {
		region: 'us-east-2',
		userPoolId: 'us-east-2_G43SkZOZF',
		userPoolWebClientId: '43lo6tposab52aj6ft6u4c33cb',
	},
});
const rootElement = document.querySelector('#root');
const root = createRoot(rootElement);
const consoleWarning = console.warn;

console.warn = (...args) => {
	// Check if it's an Apollo "Missing field ..." message
	if (typeof args[0] === 'string' && args[0].includes('Missing field')) {
		return; // Ignore this specific warning
	}

	consoleWarning(...args);
};

// A shell-started sign-in that finished in the system browser only needs to
// hand its code back to the app; the app itself does not boot here (ERIN-8561).
if (!takeOverShellSsoReturn()) {
	root.render(
		<ErrorHandler>
			<WithApiProvider Component={App} />
		</ErrorHandler>
	);
}
